<template>
  <communication-profile-numbers
    :placement="placement"
    trigger="click"
    close-on-auto-selection
  >
    <template #label="{ numbersTooltipVisible }">
      <div class="group flex items-center gap-x-2">
        <lf-pill
          size="sm"
          class="ml-2 h-[26px] cursor-pointer font-bold uppercase"
          color-index="15"
          data-cy="assign-number-toggle"
        >
          <div class="flex items-center space-x-2">
            <div class="truncate text-left">
              <span v-if="!!savedPhoneNumber" class="text-label">
                {{ prepend }}
                {{ savedPhoneDisplay }}
              </span>
              <span v-else>
                {{ $t("TWILIO.COMMUNICATE_FROM") }}
              </span>
            </div>
            <icon-base
              :icon="IconArrowUp"
              height="10"
              width="10"
              :class="{
                '-translate-y-1 rotate-180': !numbersTooltipVisible,
              }"
            />
          </div>
        </lf-pill>
        <copy-to-clipboard-button
          v-if="savedPhoneNumber?.phone_number"
          class="hidden group-hover:block"
          :value="savedPhoneNumber.phone_number"
          @click.stop
        />
      </div>
    </template>
  </communication-profile-numbers>
</template>

<script setup lang="ts">
import { useTwilio } from "@/hooks/communicationProviders";

import CopyToClipboardButton from "@/components/CopyToClipboardButton.vue";
import CommunicationProfileNumbers from "@/components/communication/CommunicationProfileNumbers.vue";
import IconArrowUp from "@/components/icons/IconArrowUp.vue";

import type { TippyComponent } from "vue-tippy";

const { prepend = "", placement = "bottom-start" } = defineProps<{
  prepend?: string;
  placement?: TippyComponent["popperOptions"]["placement"];
}>();

const { savedPhoneNumber, savedPhoneDisplay } = useTwilio();
</script>
